// extracted by mini-css-extract-plugin
export default {"point":"PointRight_point"};